var GenderType;
(function (GenderType) {
    GenderType["MALE"] = "MALE";
    GenderType["FEMALE"] = "FEMALE";
    GenderType["OTHER"] = "OTHER";
})(GenderType || (GenderType = {}));
export {};
//# sourceMappingURL=user.interface.js.map